<template>
<div class="otherChatBox clear-fix" >
<!--  头像-->
  <div class="img" @click="altSomeOne">
    <img :src="getHeadImg" alt="">
  </div>

<!--  对话-->
  <div class="chatBox" @click="altSomeOne">
    <div class="name">{{ name }}</div>
    <div class="text">{{ text }} <span v-if="hasReplyName">@{{ replyName }}</span> </div>
  </div>
</div>
</template>

<script>
export default {
  name: "otherChat",
  computed:{
    getHeadImg(){
      if(this.headImg!=''){
        return this.headImg
      }else{
        return require("../../../../assets/app/logo.png")
      }
    },
    hasReplyName(){
      if(this.replyName==null){
        return false
      }
      if(this.replyName!=''){
        return true
      }
      return false
    }
  },
  props:{
    headImg:{
      type: String,
      default: require("../../../../assets/app/logo.png")
    },
    name:{
      type: String,
      default: '游客'
    },
    userId:{
      type: Number,
      required: true
    },
    text: {
      type: String,
      default: '...'
    },
    replyName: {
      type: String,
      default: ''
    }
  },
  methods:{
    altSomeOne(){
      console.log("alt some one")
      let obj = {
        'userId': this.userId,
        'userName': this.name
      }
      this.$emit("altSomeOne", obj)
    }
  }
}
</script>

<style scoped>
.otherChatBox{
  position: relative;
  width: 100%;
  margin-top: 40px;
  /*background-color: #ff5777;*/
}
.img{
  float: left;
  width: 120px;
  height: 120px;
  /*background-color: #07c160;*/
  border-radius: 120px;
  border: none;
}
.img img{
  border-radius: 120px;
}

.chatBox{
  float: left;
  max-width: 580px;
  min-height: 100px;
  /*background-color: #0c83ae;*/
  padding-left: 28px;
  overflow-wrap: break-word;
}
.name{
  font-size: 35px;
  color: #b2b2b2;
  margin-bottom: 10px;
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text{
  font-size: 42px;
  color: #06050b;
  background-color: whitesmoke;
  border-radius: 6px;
  padding: 20px;
  line-height: 54px;
}
.text span{
  color: #0054ff;
}
</style>